import { api } from '@/lib/api';

export type OficinaFinanceiroLocacao = 'EM_DIA' | 'ATRASADO';
export interface OficinaCompanyOption {
  id: string;
  name: string;
}

export interface OficinaBoardOrder {
  id: string;
  osCodigoErp: string;
  clienteNome: string;
  veiculoPlaca: string;
  veiculoMarca: string | null;
  veiculoModelo: string | null;
  veiculoAnoFabricacao: number | null;
  dataEntrada: string;
  dataPrevistaSaida: string;
  numeroLocacao: string | null;
  financeiroLocacao: OficinaFinanceiroLocacao;
  setorServico: string;
  diasDesdeEntrada: number;
  /** Presente após API com campos de cor (import ERP). */
  corSetorHex?: string | null;
  corVeiculoTexto?: string | null;
  /** tecnicos_nomes (webhook / espelho API) */
  tecnicosNomes?: string | null;
}

export interface OficinaBoardColumn {
  setor: string;
  ordens: OficinaBoardOrder[];
}

export async function fetchOficinaCompanies(): Promise<OficinaCompanyOption[]> {
  const res = await api.get('/oficina/companies');
  return res.data.data?.companies ?? [];
}

export async function fetchOficinaBoard(companyId: string): Promise<{ columns: OficinaBoardColumn[] }> {
  const res = await api.get('/oficina/board', { params: { companyId } });
  return res.data.data;
}

export interface OficinaMetrics {
  totalEmExecucao: number;
  financeiroEmDia: number;
  financeiroAtrasado: number;
  mediaDiasDesdeEntrada: number;
  saidaAtrasadaCount: number;
  longasNaOficinaCount: number;
  percentFinanceiroEmDia: number;
  percentFinanceiroAtrasado: number;
  setorMaisCarregado: { setor: string; count: number } | null;
  saidaNoPrazoCount: number;
  criticasCount: number;
  porSetor: { setor: string; count: number }[];
  diasNaOficinaBuckets: { faixa: string; count: number }[];
  updatedAt: string;
}

export async function fetchOficinaMetrics(companyId: string): Promise<OficinaMetrics> {
  const res = await api.get('/oficina/metrics', { params: { companyId } });
  return res.data.data;
}

export async function uploadOficinaCsv(file: File): Promise<{
  processed: number;
  created: number;
  updated: number;
  errors: string[];
}> {
  const form = new FormData();
  form.append('csv', file);
  const res = await api.post('/oficina/import-csv', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data.data;
}

export interface OficinaApiSyncResult {
  success: boolean;
  totalReceived: number;
  totalInserted: number;
  errors: string[];
  periodo: { inicio: string; fim: string };
  skipped?: boolean;
  message?: string;
}

/** Espelho ERP: getLocacaoOrdensServicos (mesmo token da config que get-locacoes-cliente), trunca oficina_ordens_servico e reinsere. */
export async function syncOficinaFromApi(): Promise<OficinaApiSyncResult> {
  const res = await api.post('/oficina/sync-api');
  return res.data.data as OficinaApiSyncResult;
}
